import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

export function useReference() {
  const [ref, setRef] = useState({ districts: [], campuses: [], teams: [] });
  const load = useCallback(async () => {
    const { data } = await api.get("/reference");
    setRef(data);
  }, []);
  useEffect(() => { load(); }, [load]);
  return { ref, reloadRef: load };
}
